/* eslint-disable import/no-cycle */
import { combineReducers } from 'redux';

import actions from './actions/reducer';
import canvases from './canvases/reducer';
import conversations from './conversations/reducer';
import fields from './fields/reducer';
import trackers from './trackers/reducer';
import trackersAttributes from './trackersAttributes/reducer';
import targets from './targets/reducer';
import appSetup from './appSetup/reducer';
import project from './project/reducer';
import reactions from './reactions/reducer';

export default combineReducers({
  actions,
  appSetup,
  canvases,
  conversations,
  fields,
  trackers,
  trackersAttributes,
  targets,
  project,
  reactions,
});
